import Layout from '../components/Layouts/AdminLayout'
import HeaderContainer from '../containers/Header/Header.container'
import SidebarContainer from '../containers/Sidebar/Sidebar.container'
import PensionCalculationListContainer from '../containers/PensionCalculation/PensionCalculationList.container'
import SupportHelpCard from '../containers/Support/SupportHelpCard'

const PensionCalculation = () => {
  return (
    <Layout
      header={<HeaderContainer />}
      sidebar={<SidebarContainer />}
      title="Mis Pensiones"
    >
      <PensionCalculationListContainer />
      <SupportHelpCard />
    </Layout>
  )
}

export default PensionCalculation
